import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { Core } from "../helpers/core";
import store from "../store";
import { AppIcons } from "../constants/app-icons";
// import UserGemsService from "./user.gems.service";
export default class FilesService extends ApiService {
  namespace = "file";
  template = "defaultTemplate";
  DOMAIN = 169;
  icon = "GreenCabinet";
  Width = 1200;
  action = "action";
  singular = this.terminology.file.singular;
  plural = this.terminology.file.plural;
  vowel = this.terminology.file.vowel;

  deleteItems = [];

  gemItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: "Files" }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "uploadFile",
      label: "Upload Payables Dcouments",
      icon: AppIcons.PLUS,
    },
    {
      key: "PrintCheck",
      label: "Print Check",
      icon: AppIcons.PLUS,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.DOCUMENT,
      field: "display_name",
      width: 2,
      click: (data) => {
        let extension = data.extension;
        if ("P" == extension || "D" == extension) {
          return [
            { type: "lazy", data: { hierarchy_id: data.id, page: 1 } },
            {
              type: "load",
              loader: this.get({ hierarchy_id: data.id }, "tree"),
            },
          ];
        } else {
          return null;
        }
      },
      template: (data) => {
        let extension = data.extension;
        if ("P" == extension) extension = "Drawer";

        if ("D" == extension) extension = "FolderHorizontalClosed";

        let icon = require("@/assets/images/icons/16x16/" + extension + ".png");
        let info = '<img src="' + icon + '" style="width: 16px" />';
        info += " " + data.display_name;
        return info;
        // return data.extension;
      },
    },
    {
      header: this.t("filed"),
      icon: AppIcons.CALENDAR,
      field: "date",
    },
    {
      header: this.t("linkedTo") + "...",
      icon: AppIcons.LINK,
      field: "domain",
    },
    {
      header: this.t("type"),
      icon: AppIcons.DOCUMENT,
      field: "extension",
      template: (data) => {
        let extension = data.extension;
        if ("P" == extension) extension = "Drawer";
        if ("D" == extension) extension = "Folder";
        return extension;
        // return data.extension;
      },
    },

    {
      header: this.t("size"),
      icon: AppIcons.DOCUMENT,
      field: "size",
      template: (data) => {
        return Core.bytesToSize(data.size);
      },
    },
    {
      icon: AppIcons.HAND_WITH_APPLICATION,
      field: "icon1",
    },
    {
      icon: AppIcons.DOWNLOAD,
      field: "downlaod",
    },
    {
      icon: AppIcons.LOCK,
      field: "lock",
    },
    {
      icon: AppIcons.COMMENT,
      field: "comment",
    },
  ];
  gemMenuItems = [
    {
      key: "uploadFile",
      label: "Uplaod Payable Documents",
      icon: PrimeIcons.ARROW_UP,
    },
    {
      key: "PrintCheck",
      label: "Print Check",
      icon: PrimeIcons.ARROW_UP,
    },
    // {
    //   key: "uploadFile",
    //   label: "Upload Other Documents",
    //   icon: PrimeIcons.ARROW_UP,
    // },
    // {
    //   key: "create",
    //   label: "Create a Drawer",
    //   services: -2,
    //   icon: PrimeIcons.FOLDER,
    // },
    // {
    //   key: "create",
    //   label: "Create a Folder",
    //   services: -2,
    //   icon: PrimeIcons.FOLDER,
    // },
  ];

  listDeleteItems = [
    {
      key: "del 1",
      label: "Permanent delete",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "del 2",
      label: "Permanent delete 2",
      icon: PrimeIcons.DELETELEFT,
    },
  ];

  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: "Open this File...",
        icon: AppIcons.EDIT,
      },

      {
        key: "announce",
        label: "announceThisEntity",
        services: -3,
        icon: AppIcons.ANNOUNCEMENT,
      },
      {
        key: "email",
        label: "emailThisEntity",
        icon: AppIcons.MAIL,
        services: 208,
      },
      {
        key: "bookmark",
        label: "bookmarkThisEntity",
        icon: AppIcons.BOOKMARK,
      },
      {
        key: "downlaod",
        label: "Download this file...",
        icon: AppIcons.ARROW_SOUTH,
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? AppIcons.DISABLE : AppIcons.ENABLED,
      },
      {
        key: "crop",
        label: "Crop this image...",
        icon: AppIcons.CROP,
      },
      {
        key: "editImage",
        label: "Edit this image...",
        icon: AppIcons.EDIT,
      },
      {
        key: "upload",
        label: "Upload new version...",
        icon: AppIcons.HAND_WITH_APPLICATION,
      },
      {
        key: "move",
        label: "Move this file",
        icon: AppIcons.MOVE,
      },
      {
        key: "edit",
        label: "View Comments",
        icon: AppIcons.COMMENT,
        services: -45,
      },
      {
        key: "upload",
        label: "Share this file",
        icon: AppIcons.HAND_WITH_APPLICATION,
      },
      {
        key: "stop",
        label: "Stop sharing this file",
        icon: AppIcons.HAND_WITH_APPLICATION,
      },
      {
        key: "checkout",
        label: "Check-out this file...",
        icon: AppIcons.LOCK2,
      },

      {
        key: "delete",
        label: "Delete",
        icon: AppIcons.TRASH,
      },
    ];
    return listMenuItems;
  }

  listingControls = [
    {
      key: "share",
      label: "Share",
      icon: AppIcons.HAND_WITH_APPLICATION,
      action: () => {},
    },
    {
      key: "move",
      label: "Move",
      icon: AppIcons.FOLDER,
      action: () => {},
    },
    {
      key: "delete",
      label: "Delete",
      icon: AppIcons.CIRCLE_WITH_X,
      action: (context, selectedItems) => {
        selectedItems.forEach((element) => {
          // Note: We have calculated all the files from directoris recursively.

          this.deleteItems.push({ id: element.id });

          context.$confirm.require({
            message:
              `Are you sure you want to delete the selected ` +
              selectedItems.length +
              ` File?`,
            dialogType: "confirm",
            accept: () => {
              this.deleteItems.forEach((item) => {
                this.delete(`/` + item.id).then((res) => {
                  context.emitter.emit("files-list", res);
                });
              });
            },
          });
        });
      },
    },
    {
      key: "inactive",
      label: "Inactive",
      icon: AppIcons.SILVER_BOX,
      action: () => {},
    },
    {
      key: "zip",
      label: "Zip & Download",
      icon: AppIcons.SAILING_SHIP,
      action: (ctx, items) => {
        ctx.$toast.add({
          severity: "info",
          summary: "Preparing Zip",
          detail: "Compressing selected file(s).",
        });
        let data = {
          files: items,
        };
        this.post(data, "zip").then((res) => {
          let zipPath = this.filesDir(res.filename);
          let detail = "Files Compressed: " + res.numFiles + ".";
          detail +=
            '<br /> <a href="' + zipPath + '" target="_blank">Download</a>';
          ctx.$toast.add({
            severity: "success",
            summary: "Zip is ready for download",
            detail: detail,
            group: "custom",
          });
          ctx.loadLazyData(this);
        });
      },
    },
    {
      key: "gallery",
      label: "Gallery",
      icon: AppIcons.IMAGE_SUNSET,
      action: () => {},
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
    {
      key: "delete",
      label: this.t("trashBin"),
      icon: AppIcons.TRASH,
    },
  ];
  filterItems = [
    {
      name: "Drawer",
      key: "drawer",
      serviceId: "-40",
      value: "-40",
      realm: "0",
      add: "loader",
      edit: "loader",
      item: { key: "id", label: "display_name" },
      selected: true,
    },
    {
      name: "Associations",
      key: "assoc",
      serviceId: "17",
      value: "17",
      realm: "2",
      add: "create",
      edit: "listing",
      selected: false,
    },
    {
      name: "Types",
      key: "types",
      serviceId: "2",
      value: "2",
      realm: "2",
      add: "create",
      edit: "listing",
      selected: false,
    },
    {
      name: "Extension",
      key: "extension",
      serviceId: "14",
      value: "14",
      realm: "2",
      add: "create",
      edit: "listing",
      selected: false,
    },
    {
      name: "Categories",
      key: "category",
      serviceId: "3",
      value: "3",
      realm: "1",
      add: "create",
      edit: "listing",
      selected: false,
    },
  ];
  delete(item) {
    let id = item.id;
    return this.post({ id: id, type: item.extension }, `remove`).then(
      (res) => res.data,
    );
  }
  async getListFilter(item) {
    let params = { key: item.key };
    return this.scanFilterItmes(params);
  }
  constructor() {
    super("files");
  }
}
